<template>
    <div>
        <base-loading :visible="isLoading" />
        <new-shelter-fee :title="$t('add') | capitalize" v-model="addShelterFeeModal" :clients="clients" @add="onAdd"/>
        <div class="grid grid-cols-12 gap-4">
             <div class="col-span-full md:col-span-2 md:col-start-1 xs:col-start-1">
               <vs-button color="success" icon="add" @click="add">{{ $t('add') | capitalize  }}</vs-button>
            </div>
            <div class="col-span-full md:col-span-2 md:col-start-11  xs:col-start-1">
                <search-input v-model="search" @search="onSearch" @clear="onSearch" />
            </div>
            <div class="col-span-full col-start-1">
                <reports-table :items="items" @loadMore="loadMore" @sortChanged="onSortChanged" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useShelterFee } from '../../composables/useShelterFee.js'
import ReportsTable from './components/ReportsTable.vue'
import BaseLoading from '@/views/app/components/BaseLoading.vue'
import SearchInput from '@/views/app/components/SearchInput.vue'
import newShelterFee from './components/newShelterFee.vue'
import { capitalize } from '../../../../../utils/helpers.js'

const search = ref('')
const shelterFee = useShelterFee()
const sort = ref({})

const items = computed(() => shelterFee.state.items)
const currentPage = computed(() => shelterFee.state.currentPage)
const lastPage = computed(() => shelterFee.state.lastPage)
const isLoading = computed(() => shelterFee.state.loading)
const addShelterFeeModal = ref(false)
const clients = ref([])

const loadData = async (params = {}) => {
    const payload = {
        page: shelterFee.state.currentPage || 1,
        search: search.value,
        column: sort.value.column,
        order: sort.value.order,
        ...params
    }
    const result = await shelterFee.getReports(payload)
    if (!result.success) console.log('Error al cargar...')
}

const loadMore = async () => {
    if (currentPage.value >= lastPage.value) return
    const newPage = shelterFee.state.currentPage + 1
    await loadData({ page: newPage })
}

const onSearch = async () => {
    await loadData({ page: 1, search: search.value })
}

const onSortChanged = async (sortData) => {
    sort.value.column = sortData.key
    sort.value.order = sortData.order
    await loadData({ column: sort.value.column, order: sort.value.order , page:1})
}

const getClients = async () => {
    const result = await shelterFee.getClients()
    if (!result.success) console.log('Error al cargar...')
    clients.value = [...result.data.clients]
}

const add = () => {
    addShelterFeeModal.value = true
}

const onAdd = async (payload) => {
    addShelterFeeModal.value = false
    console.log(payload)
}

onMounted(() => {
    loadData()
    getClients()
})

</script>
